export const testOptions = [
  {
    group: 'Test Psicologici',
    items: [
      {
        value: 'test1',
        label: 'Test di Benessere',
        subtitle: 'Misura il benessere psicologico',
        icon: '/products/wellbeing.png',
      },
      {
        value: 'test2',
        label: 'Test di Ansia',
        subtitle: 'Valuta i livelli di ansia',
        icon: '/products/wellbeing.png',
      },
    ],
  },
  {
    group: 'Test Cognitivi',
    items: [
      {
        value: 'test3',
        label: 'Test di Performance',
        subtitle: 'Valuta le prestazioni cognitive',
        icon: '/products/wellbeing.png',
      },
      {
        value: 'test4',
        label: 'Test di Memoria',
        subtitle: 'Misura la capacità mnemonica',
        icon: '/products/wellbeing.png',
      },
    ],
  },
  {
    group: 'Test di Esposizione',
    items: [
      {
        value: 'test5',
        label: 'Test di Esposizione VR',
        subtitle: "Testa la gestione dell'ansia in VR",
        icon: '/products/wellbeing.png',
      },
      {
        value: 'test6',
        label: 'Test di Esposizione Graduale',
        subtitle: 'Esposizione progressiva alle fobie',
        icon: '/products/wellbeing.png',
      },
    ],
  },
];
